import { Table } from "antd";
import React from "react";

import { usePresalePasswordsTable } from "./hooks";
import { PresalePasswordsTableProps } from "./types";

const PresalePasswordsTable: React.FC<PresalePasswordsTableProps> = (props) => {
  const table = usePresalePasswordsTable(props);

  return <Table rowKey="id" {...table} pagination={false} />;
};

export default PresalePasswordsTable;
